import {h, Fragment} from "preact"
import { useResponse, AutocompleteElement, Keywords } from "@nosto/preact"
import { useEffect, useRef } from "preact/hooks";
import { defaultConfig } from "../config"
import AutocompleteProduct from "./elements/AutocompleteProduct"

export default function Autocomplete() {
    const { products, keywords } = useResponse();
    const inputRef = useRef(null);
    const closeSearchBtnRef = useRef(null);
    const keywordsContainerRef = useRef(null);

    if (!products?.hits?.length && !keywords?.hits?.length) {
        return
    }

    useEffect(() => {
        // query elements
        inputRef.current = document.getElementById('Search-In-Modal');
        closeSearchBtnRef.current = document.querySelector('.search-modal__close-button');
    }, [])

    useEffect(() => {
        // 'enter' key press, close modal
        const handleKeydown = (event) => {
            if (event.key === 'Enter' && closeSearchBtnRef?.current) {
                closeSearchBtnRef.current.click();
            }
        }

        const inputEl = inputRef.current;
        if(inputEl) {
            inputEl.addEventListener('keydown', handleKeydown);
            return () => inputEl.removeEventListener('keydown', handleKeydown);
        }
    }, [inputRef, closeSearchBtnRef])

    useEffect(() => {
        // keywords click, close modal
        const handleKeywordClick = (event) => {
            if(event.target.closest('.keywords-item') && closeSearchBtnRef.current) {
                closeSearchBtnRef.current.click();
            }
        }

        if(keywordsContainerRef.current) {
            keywordsContainerRef.current.addEventListener('click', handleKeywordClick);
            return () => keywordsContainerRef.current.removeEventListener('click', handleKeywordClick);
        }
    }, [keywordsContainerRef, closeSearchBtnRef])


    const toggleSearchModal = () => {
        if(closeSearchBtnRef.current) {
            closeSearchBtnRef.current.click();
        }
    }

    return (
        <div class="ns-autocomplete results" data-nosto-element="autocomplete">
            
            <div class="ns-autocomplete-section keywords">
                <div class="ns-autocomplete-section-header">Suggestions</div>
                <div class="ns-autocomplete-keywords-container" ref={keywordsContainerRef}>
                    <Keywords
                        hits={keywords.hits}
                        keywordComponent={Keyword}
                        elementComponent={Element}
                        keywordInCategoryComponent={KeywordInCategory}
                    />
                </div>
            </div>

            <div class="ns-autocomplete-section products">
                <div class="ns-autocomplete-section-header">Recommended Products</div>
                <div class="ns-autocomplete-products-container">
                    {products?.hits?.map((hit, index) => (
                        <AutocompleteProduct product={hit} key={hit.productId || index} />
                    ))}
                </div>
                <button type="submit" class="ns-autocomplete-submit" onClick={toggleSearchModal}>
                    <span class="ns-autocomplete-submit-text">View All Results</span>
                    <svg class="icon-arrow" viewBox="0 0 15 13" version="1.1" xmlns="http://www.w3.org/2000/svg">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Type-Ahead---Mobile" transform="translate(-265.000000, -973.000000)" stroke="#ffffff" stroke-width="1.2"><g id="Group-2" transform="translate(92.500000, 969.000000)"><g id="Group-8" transform="translate(172.500000, 5.000000)"><polyline id="Stroke-1" points="8.5 0 14 5.5 8.5 11"></polyline><line x1="14" y1="5.5001" x2="0" y2="5.5001" id="Stroke-3"></line></g></g></g></g>
                    </svg>
                </button>
            </div>

        </div>
    )
}

function Keyword({ hit }) {
    return (
        <span data-nosto-element="keyword">
            {hit?._highlight?.keyword ? (
                <span
                    dangerouslySetInnerHTML={{
                        __html: hit._highlight.keyword
                    }}
                ></span>
            ) : (
                hit.keyword
            )}
        </span>
    )
}

function Element({ hit, keywordComponent, filter }) {
    return (
        <AutocompleteElement hit={hit} filter={filter} class="keywords-item">
            {keywordComponent}
        </AutocompleteElement>
    )
}

function KeywordInCategory({ category, children }) {
    return (
        <span class="ns-clickable">
            {category?.value ? (
                <span>
                    {children}{" "}
                    <span class="ns-keyword-in-category">
                        in <span>{category.value}</span>
                    </span>
                </span>
            ) : (
                children
            )}
        </span>
    )
}
